import styled from 'styled-components';
export const UnorderedList = styled.ul `
  font-size: ${({ theme }) => theme.fontSizes.s};
  padding-inline-start: ${({ theme }) => theme.space.x6};
  line-height: 1.5;
`;
